import React, { useEffect } from "react";
import { Row, Col, Button } from "antd";
import { useOutletContext  } from "react-router-dom";
import {
  RiseOutlined, WarningOutlined, PieChartOutlined,
} from '@ant-design/icons';
import StackedBarChart from "./StackedBarChart";
import { useNavigate } from "react-router-dom";
import Pie from "./pie";
import TotalExcludingTax from "./TotalExcludingTax";
import Cards from "./cards";
import Table from './Table';

function Dashboard() {
  const navigate = useNavigate();
  const { isDarkMode ,groupId, companyId} = useOutletContext();
  const report = () => {
    navigate('/reports/TotalTaxAmountReport');
  };

  useEffect(() => {
    console.log("companyId:",companyId ,"groupId:",groupId)
  }, [companyId,groupId]);

  const formatSupplierName = (str) => {
    const words = str.split(' ');
    return words.length > 0 
      ? words[0] + ' ' + words.slice(1).map(word => word[0]).join(' ')
      : str;
  };

  return (
    <div>
      <Row gutter={16} className="mt-12">
        <Col xl={12} lg={24} md={24} sm={24} xs={24}>
          <Cards/>
          <Row className="mt-16">
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
            <div class="border-container">
            <Button type="default" variant="dashed" className="card-button inactive-b" size="large" icon={<WarningOutlined />} shape="circle">
            </Button>
            <Table/>
            </div>
            </Col>
            
          </Row>
        </Col>
        <Col xl={12} lg={24} md={24} sm={24} xs={24} className="">
        <div class="border-container">
            <Button type="default" variant="dashed" className="card-button inactive-b" size="large" icon={<RiseOutlined />} shape="circle">
            </Button>
            <StackedBarChart isDarkMode={isDarkMode} />
          </div>
        </Col>

      </Row>
      <Row gutter={16} className="mt-16">
        {/* <Col xl={9} lg={24} md={24} sm={24} xs={24}>
          <div class="border-container">
            <Button type="primary" variant="dashed" onClick={report} className="card-button" size="large" icon={<ExportOutlined />} shape="circle">
            </Button>
            <TotalIncludingTax isDarkMode={isDarkMode} aRData={aRData} />
          </div>
        </Col> */}
        {/* <Col xl={9} lg={24} md={24} sm={24} xs={24}>
          <div class="border-container">
            <Button type="primary" className="card-button" onClick={report} size="large" icon={<ExportOutlined />} shape="circle">
            </Button>
            
          </div>
        </Col> */}
        <Col xl={18} lg={24} md={24} sm={24} xs={24}>
        
        <TotalExcludingTax isDarkMode={isDarkMode}/>
        
        </Col>
        <Col xl={6} lg={24} md={24} sm={24} xs={24}>
          <div class="border-container">
            <Button type="default" className="card-button inactive-b" size="large" icon={<PieChartOutlined />} shape="circle">
            </Button>
            <Pie isDarkMode={isDarkMode} />
          </div>
        </Col>
      </Row>
      {/* <Row gutter={16} className="mt-16">
        <Col xl={8}>
          <div class="border-container">
            <Button type="primary" className="card-button" size="large" icon={<RiseOutlined />} shape="circle">
            </Button>
            <Line2 isDarkMode={isDarkMode} />
          </div>
        </Col>
        <Col xl={8}>
          <div class="border-container">
            <Button type="primary" className="card-button" size="large" icon={<RiseOutlined />} shape="circle">
            </Button>
            <Pie2 isDarkMode={isDarkMode} />
          </div>
        </Col>
        <Col xl={8}>
          <div class="border-container">
            <Button type="primary" className="card-button" size="large" icon={<RiseOutlined />} shape="circle">
            </Button>
           
          </div>
        </Col>
      </Row> */}
    </div>
  );
}

export default Dashboard;
